import type {
  UpdateProfilePicPayload,
  UploadListData,
  UploadListParams,
  UploadPayload,
  Uploads,
} from '@/libs/interfaces'

import { MOCK_PLACEHOLDER_IMAGE_URL, mockUploads } from '../fixtures/uploads'
import { delay, genID } from '../helpers'
import { createEntityStore } from '../store'

const uploadStore = createEntityStore<Uploads, 'uploadID'>(mockUploads, 'uploadID')

export const uploadsApiMock = {
  upload: async (payload: UploadPayload): Promise<void> => {
    uploadStore.insert({
      uploadID: genID('upload'),
      fileName: payload.fileName,
      profilePic: payload.profilePic,
      s3Key: `mock/uploads/${payload.fileName}`,
    })
    return delay(undefined)
  },

  list: async (params: UploadListParams): Promise<UploadListData> => {
    const uploads = params.profilePic
      ? uploadStore.find((upload) => upload.profilePic === params.profilePic)
      : uploadStore.getAll()
    return delay({
      limit: params.limit ?? uploads.length,
      uploads,
    })
  },

  getPreSignedUrl: async (_params: { orgID: string; uploadID: string }): Promise<string> =>
    delay(MOCK_PLACEHOLDER_IMAGE_URL),

  delete: async (params: { orgID: string; uploadID: string }): Promise<{ uploadID: string }> => {
    uploadStore.remove(params.uploadID)
    return delay({ uploadID: params.uploadID })
  },

  updateProfilePic: async (
    payload: UpdateProfilePicPayload,
  ): Promise<{ uploadID: string; profilePic: boolean }> => {
    uploadStore.update(payload.uploadID, { profilePic: payload.profilePic })
    return delay({ uploadID: payload.uploadID, profilePic: payload.profilePic })
  },
}
